module.exports = __webpack_public_path__ + "img/AT0000000571776.1d03c5c8.png";